import React from 'react';
import { Link } from 'gatsby'
import BonsPLansJeunesFormFilterThemes from './BonsPLansJeunesFormFilterThemes';
import BonsPLansJeunesFormFilterPublics from './BonsPLansJeunesFormFilterPublics';

const BonsPlansJeunesForm = ({
	bonsPLansJeunesFilterMySearch, 
	bonsPLansJeunesFilterFilterActiveThemes, 
	OnChangeFilterThemes, 
	bonsPLansJeunesFilterFilterActivePublics, 
	OnChangeFilterPublics, 
	onSubmit, 
	...rest
}) => {
	// Validation des props
	if (!onSubmit || typeof onSubmit !== 'function') {
		return null;
	}

	return (
		<form 
			id="bons-plans-jeunes-filters" 
			className="generic-filters bons-plans-jeunes-filters" 
			onSubmit={onSubmit}
			role="search"
			aria-label="Formulaire de recherche des bons plans jeunes"
			aria-describedby="bons-plans-jeunes-filters-description"
		>
			<div id="bons-plans-jeunes-filters-description" className="visually-hidden">
				Formulaire de recherche et de filtrage des bons plans jeunes avec options de thèmes, publics et recherche textuelle
			</div>
			
			<div className="generic-filters-header bons-plans-jeunes-filters-header">
				<h1 className="generic-filters-header-title bons-plans-jeunes-filters-header-title">
					<span>Bons Plans</span> Jeunes
				</h1>
				<div className="bons-plans-jeunes-filters-header-catalog">
					<p className="generic-filter-button bons-plans-jeunes-filter-button">
						<Link 
							rel="noopener noreferrer" 
							className="btn btn-primary btn-lg btn-pink-3" 
							to="/services-infos-pratiques/jeunesse/bons-plans-pour-les-jeunes/catalogue-de-solutions-obligation-formation-jeunes-16-18-ans/"
							aria-label="Accéder au catalogue de solutions pour l'obligation de formation des jeunes de 16 à 18 ans"
						>
							Catalogue de solutions : Obligation de formation 16-18 ans
						</Link>
					</p>
				</div>
			</div>
			
			<div className="generic-fields bons-plans-jeunes-filters-fields">
				<BonsPLansJeunesFormFilterThemes 
					bonsPLansJeunesFilterFilterActiveThemes={bonsPLansJeunesFilterFilterActiveThemes} 
					OnChangeFilterThemes={OnChangeFilterThemes} 
				/>
				<BonsPLansJeunesFormFilterPublics 
					bonsPLansJeunesFilterFilterActivePublics={bonsPLansJeunesFilterFilterActivePublics} 
					OnChangeFilterPublics={OnChangeFilterPublics}
				/>
				
				<div className="generic-filters-search bons-plans-jeunes-filters-search">
					<div className="generic-filters-search-group bons-plans-jeunes-filters-search-group">
						<div className="generic-filters-search-text bons-plans-jeunes-filters-text">
							<label htmlFor="bons-plans-jeunes-filters-text" className="visually-hidden">
								Rechercher dans les bons plans jeunes
							</label>
							<input 
								id="bons-plans-jeunes-filters-text" 
								{...rest}
								aria-label="Rechercher dans les bons plans jeunes"
								aria-describedby="bons-plans-jeunes-filters-description"
							/>
						</div>
						<div className="generic-filters-search-submit bons-plans-jeunes-filters-submit">
							<button 
								type="submit"
								className="btn btn-primary btn-lg btn-pink-3"
								aria-label="Lancer la recherche des bons plans jeunes"
								aria-describedby="bons-plans-jeunes-filters-description"
							>
								Rechercher
							</button>
						</div>
					</div>
				</div>
				
				<div className="generic-filters-link bons-plans-jeunes-filters-link">
					<p className="generic-filter-button bons-plans-jeunes-filter-button">
						<Link 
							rel="noopener noreferrer" 
							className="btn btn-primary btn-lg btn-pink-3" 
							to="/services-infos-pratiques/jeunesse/bons-plans-pour-les-jeunes/videos-bons-plans-jeunes/"
							aria-label="Accéder aux vidéos des bons plans jeunes"
						>
							Vidéos Bons Plans Jeunes
						</Link>
					</p>
					<p className="generic-filter-button bons-plans-jeunes-filter-button">
						<a 
							rel="noopener noreferrer" 
							className="btn btn-primary btn-lg btn-pink-3" 
							target="_blank" 
							href="https://services.ville-roubaix.fr/demarches/bpj"
							aria-label="Contacter le service des bons plans jeunes (s'ouvre dans un nouvel onglet)"
						>
							Contact
						</a>
					</p>
				</div>
			</div>
		</form>
	);
};

export default BonsPlansJeunesForm;
